export default "__VITE_ASSET__BPVdX9_L__"